import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

/**
 * Search component for tree filtering
 *
 * Features:
 * - Search icon indicator
 * - Clear button when text entered
 * - Disabled state support
 */
const TreeSearch = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  disabled = false
}) => {
  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => onChange('')}
              edge="end"
              disabled={disabled}
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
      sx={{ mb: 2 }}
    />
  );
};

export default TreeSearch;
